// Mise en forme des montants et des valeurs de la grille (affichage uniquement)

const nf = (digits) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: digits })

export const formatEur = (value, digits = 2) =>
  value === null || value === undefined || Number.isNaN(Number(value)) ? '—' : `${nf(digits).format(Number(value))} €`

export const formatPct = (value, digits = 4) =>
  value === null || value === undefined || Number.isNaN(Number(value)) ? '—' : `${nf(digits).format(Number(value))} %`

// Valeur brute d'une variable de la grille (chaîne comme dans l'env) selon son type et son unité
export function formatVariable(variable, raw) {
  const value = raw ?? variable.value
  if (variable.kind === 'boolean') return value === 'false' ? 'Non' : value === null ? '—' : 'Oui'
  if (value === null || value === undefined) return 'non défini'
  if (variable.kind === 'optional' && String(value).trim() === '') return 'désactivé (grille directe)'
  const one = (v) => variable.unit === '%' ? formatPct(v) : variable.unit === 'EUR' ? formatEur(v) : String(v)
  if (variable.kind === 'list') return String(value).split(',').map(s => one(s.trim())).join(' · ')
  return one(value)
}

export const listOf = (raw) => String(raw ?? '').split(',').map(s => s.trim()).filter(Boolean).map(Number)
